export const SUPPORTED_PAGES = [
  'home', 'shop', 'product', 'category', 'categories', 'search', 'cart', 'checkout',
  'contact', 'signin', 'signup', 'account', 'wishlist', 'track-order', 'order-success', 'order-detail',
  'blog', 'privacy-policy', 'terms-of-service', 'shipping-policy', 'return-policy',
  'offers', 'tools', 'pc-builder',
] as const
